import React, { useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import EditTransactionModal from './_editmodal.tsx';


const BulkPaymentsTennatRow = ({ tenant, selected, onSelect, onApprove, onEdit }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  // Determine invoice status color and label
  let invoiceStatusClass = '';
  let invoiceStatusLabel = '';
  switch (tenant.invoice_status?.toLowerCase()) {
    case 'paid':
      invoiceStatusClass = 'bg-green-100 text-green-700';
      invoiceStatusLabel = 'Paid';
      break;
    case 'partial':
      invoiceStatusClass = 'bg-yellow-100 text-yellow-700';
      invoiceStatusLabel = 'Partial';
      break;
    case 'unpaid':
    default:
      invoiceStatusClass = 'bg-red-100 text-red-700';
      invoiceStatusLabel = 'Unpaid';
      break;
  }

  // Determine approval status color and label
  let approvalStatusClass = '';
  let approvalStatusLabel = tenant.approval_status || 'pending';
  switch (approvalStatusLabel.toLowerCase()) {
    case 'approved':
      approvalStatusClass = 'bg-green-100 text-green-700';
      break;
    case 'rejected':
      approvalStatusClass = 'bg-red-100 text-red-700';
      break;
    case 'pending':
    default:
      approvalStatusClass = 'bg-yellow-100 text-yellow-700';
      break;
  }

  const isApproved = tenant.approval_status === 'approved' || tenant.approval_status === 'rejected';

  const handleEdit = () => {
    setShowEditModal(true);
  };

  const handleSave = (editedData) => {
    onEdit(tenant.id, editedData);
  };

  return (
    <tr className="hover:bg-gray-50 transition">

      <td className="px-4 py-3">{tenant.name}</td>
      <td className="px-4 py-3">
        <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${approvalStatusClass}`}>
          {approvalStatusLabel}
        </span>
      </td>
      <td className="px-4 py-3">{tenant.phone_number}</td>
      <td className="px-4 py-3">
        <div className="flex flex-col">
          <span className="font-medium">{tenant.house_number}</span>
          <span className="text-gray-500 text-sm">{tenant.apartment}</span>
        </div>
      </td>

      <td className="px-4 py-3">
        KES.{Number(tenant?.paid_amount).toLocaleString('en-US')}
      </td>
      <td className="px-4 py-3">
        <div className='flex flex-col'>
          <span className="font-medium"> {tenant.transaction_id}</span>
          <span className="text-gray-500 text-sm"> {tenant.payment_method.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}</span>

        </div>
      </td>
      <td className="px-4 py-3">
        {new Date(tenant.payment_date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric"
        })}
      </td>
      {/* <td className="px-4 py-3">KES.{Number(tenant?.invoice_amount).toLocaleString('en-us')}</td>
      <td className="px-4 py-3">
        <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${invoiceStatusClass}`}>
          {invoiceStatusLabel}
        </span>
      </td> */}


      {showEditModal && (
        <EditTransactionModal
          tenant={tenant}
          onClose={() => setShowEditModal(false)}
          onSave={handleSave}
        />
      )}
    </tr>
  );
};

export default BulkPaymentsTennatRow;